import {
  ApprovalAdditionalFieldEntity,
  ApprovalRemainingTimeEntity
} from "../../../../generated/graphql";
import { Content, Label, Subscription } from "../styles";

interface TimeInfoDisplayProps {
  annualInfo?: ApprovalAdditionalFieldEntity;
  approvalRemainingTimeInfo?: ApprovalRemainingTimeEntity;
}

const TimeInfoDisplay = ({
  annualInfo,
  approvalRemainingTimeInfo
}: TimeInfoDisplayProps) => {
  return (
    <>
      {/* Annual Info Display */}
      {annualInfo?.totDay && (
        <Content>
          <Label>{`${
            annualInfo?.processType === 1 ? "총 발생일" : "총 시간"
          }`}</Label>
          <Subscription>{annualInfo?.totDay ?? ""}</Subscription>
        </Content>
      )}
      {annualInfo?.leaveDay && (
        <Content>
          <Label>{`${
            annualInfo?.processType === 1 ? "잔여일" : "잔여시간"
          }`}</Label>
          <Subscription>{annualInfo?.leaveDay ?? ""}</Subscription>
        </Content>
      )}
      {annualInfo?.useDay && (
        <Content>
          <Label>{`${
            annualInfo?.processType === 1 ? "사용일" : "사용시간"
          }`}</Label>
          <Subscription>{annualInfo?.useDay ?? ""}</Subscription>
        </Content>
      )}

      {/* Approval Remaining Time Info Display */}
      {approvalRemainingTimeInfo?.totTime && (
        <Content>
          <Label>{`${
            approvalRemainingTimeInfo?.processType === 1
              ? "총 발생일"
              : "총 시간"
          }`}</Label>
          <Subscription>
            {approvalRemainingTimeInfo?.totTime ?? ""}
          </Subscription>
        </Content>
      )}
      {approvalRemainingTimeInfo?.leaveTime && (
        <Content>
          <Label>{`${
            approvalRemainingTimeInfo?.processType === 1 ? "잔여일" : "잔여시간"
          }`}</Label>
          <Subscription>
            {approvalRemainingTimeInfo?.leaveTime ?? ""}
          </Subscription>
        </Content>
      )}
      {approvalRemainingTimeInfo?.useTime && (
        <Content>
          <Label>{`${
            approvalRemainingTimeInfo?.processType === 1 ? "사용일" : "사용시간"
          }`}</Label>
          <Subscription>
            {approvalRemainingTimeInfo?.useTime ?? ""}
          </Subscription>
        </Content>
      )}
    </>
  );
};

export default TimeInfoDisplay;
